import { z } from 'zod';
import { NON_RESERVED_PRINCIPAL_ID_REGEX } from '../constants';
import { createErrorHandler } from './helpers/error-handler';
export const uuidValidator = ({ requiredError, formatError, forbiddenError, }) => {
    let validator = z.uuid({
        error: createErrorHandler(requiredError, formatError),
    });
    if (forbiddenError) {
        validator = validator.regex(NON_RESERVED_PRINCIPAL_ID_REGEX, forbiddenError);
    }
    return validator;
};
